import 'moment-timezone';
import moment from "moment-timezone";
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCheck, FaTimes } from "react-icons/fa";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BadgeStatus, getEndpointUrl, getTimestamp } from "../../Utils/Common";
import ModalFinishInspectionMultiple from '../FormInspeksi/ModalFinishInspectionMultiple';

const TableInspeksi = () => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [query, setQuery] = useSearchParams();

    const navigate = useNavigate();

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [customers, setCustomers] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const [toggledClearRows, setToggleClearRows] = useState(false);

    const [devStatus, setDevStatus] = useState('pending');

    const [confirmSetStatusDialog, setConfirmSetStatusDialog] = useState(false);

    const isSelectable = (data) => data.id != 0;

    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);

    const loadLazyData = (q) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/inspeksi?user_id=${userLogin.role == 'admin' ? 0 : userLogin.id}&page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}` +
            `&status=${(q.get('status') !== null) ? q.get('status') : ''}` +
            `&startDate=${(q.get('startDate') !== null) ? q.get('startDate') : ''}` +
            `&endDate=${(q.get('endDate') !== null) ? q.get('endDate') : ''}`,
            {
                headers: new Headers({
                    Authorization: `Bearer ${accesToken}`,
                    // pragma: 'no-cache',
                }),
            }).then(response => response.json()).then(json => {
                if (json.status === 'ok') {
                    setTotalRecords(json.results.total);
                    setCustomers(json.results.data);
                }
                setLoading(false);
            });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        loadLazyData(query);
    }, [lazyParams]);

    useEffect(() => {
        loadLazyData(query)
    }, [query]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!globalFilterValue.trim()) {
            loadLazyData(query);
            return;
        }
        timeout.current = setTimeout(() => {
            query.set('query', globalFilterValue);
            setQuery(query);
            loadLazyData(query);
        }, 1000);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setCustomers([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedCustomers(value);
        setSelectAll(value.length === totalRecords);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        query.set('status', e.target.status.value);
        query.set('startDate', (e.target.startDate.value !== '') ? moment(e.target.startDate.value).format('YYYY-MM-DD') : '');
        query.set('endDate', (e.target.endDate.value !== '') ? moment(e.target.endDate.value).format('YYYY-MM-DD') : '');
        setQuery(query);
    };

    const resetFilter = (e) => {
        setGlobalFilterValue('');
        setStartDate('');
        setEndDate('');

        navigate('/inspeksi');
    }

    const header = (
        <>
            <Row>
                <Col md={4} sm={12} className="my-2">
                    <h5 className="me-auto fw-bold pt-2">Data Inspeksi</h5>
                </Col>
                <Col md={8} sm={12} className="my-2">
                    <div className="d-md-flex">
                        <div className="ms-auto">
                            {selectedCustomers?.length ?
                                <>
                                    <Button variant="outline-success" onClick={() => {
                                        setDevStatus('selesai');
                                        setToggleClearRows(!toggledClearRows);
                                        setConfirmSetStatusDialog(true);
                                    }} className="ms-3 pe-3"><FaCheck /> ({selectedCustomers.length}) Selesaikan Inspeksi </Button>
                                    <Button variant="outline-danger" onClick={() => {
                                        setDevStatus('cancel');
                                        setToggleClearRows(!toggledClearRows);
                                        setConfirmSetStatusDialog(true);
                                    }} className="ms-3 pe-3"><FaTimes /> ({selectedCustomers.length}) Batalkan Inspeksi </Button>
                                </> : ''
                            }
                        </div>
                    </div>
                </Col>
            </Row>
            <Form onSubmit={onSubmit}>
                <Row>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Control type="text" name="query" ref={inputRef} value={globalFilterValue} onChange={onGlobalFilterChange} autoComplete="off" placeholder="Pencarian..." />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Select name="status">
                            <option value="">- Semua Status -</option>
                            <option value="pending" selected={query.get('status') == 'pending'} >Pending</option>
                            <option value="sedang dikerjakan" selected={query.get('status') == 'sedang dikerjakan'}>Sedang Dikerjakan</option>
                            <option value="selesai" selected={query.get('status') == 'selesai'}>Selesai</option>
                        </Form.Select>
                    </Col>
                    <Col md={2}>
                        <DatePicker
                            startDate={startDate}
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            autoComplete="off"
                            placeholderText="Mulai tanggal"
                            name="startDate"
                            customInput={<Form.Control />} />
                    </Col>
                    <Col md={2}>
                        <DatePicker
                            startDate={startDate}
                            minDate={startDate}
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            autoComplete="off"
                            placeholderText="Sampai tanggal"
                            name="endDate"
                            customInput={<Form.Control />} />
                    </Col>
                    <Col md={3}>
                        <Button type="submit">Filter Data</Button>
                        <Button type="button" variant="secondary" onClick={resetFilter} className="ms-2">Reset</Button>
                    </Col>
                </Row>
            </Form>
        </>
    );

    const statusTemplate = (row) => <BadgeStatus status={row.inspectionStatus} />;

    const tglTemplate = (row) => <Moment format="DD/MM/YYYY - HH:mm A">{row.createdAt}</Moment>;

    const unitTemplate = (row) => `${row.brandName} - ${row.type} - ${row.color}`;

    const contactTemplate = (row) => <span>{row.contactName}<br /><small>{row.contactPhone}</small></span>

    const targetTemplate = (row) => row.items?.length != 0 ? `${row.items?.length} unit` : `-`;

    const priceTemplate = (row) => <NumericFormat
        value={row.price}
        displayType={'text'}
        thousandSeparator={true}
        className="fw-medium"
        prefix={'Rp'}
        renderText={(value, props) => <span {...props}>{value}</span>} />;

    const kelolaBodyTemplate = (rowData) => {
        return <SplitButton size="small" label="Detil" icon="pi pi-eye"
            onClick={(e) => rowData?.id > 108 ? navigate(`/inspector/detil/${rowData.id}`) : navigate(`/inspeksi/detil/${rowData.id}`)}
            model={[
                {
                    label: 'Form Inspeksi',
                    icon: 'pi pi-pencil',
                    command: () => rowData?.id > 108 ? navigate(`/inspector/${rowData.id}`) : navigate(`/inspeksi/${rowData.id}`)
                }
            ]} severity="secondary" text />
    };

    const onCallback = useCallback((e) => {
        setSelectedCustomers([]);
        loadLazyData(query);
    }, []);

    return (
        <Container className="mt-3">
            <DataTable
                value={customers}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['judul', 'deskripsi']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selection={selectedCustomers}
                onSelectionChange={onSelectionChange}
                selectAll={selectAll}>
                <Column selectionMode="multiple" />
                <Column field="id" header="ID" />
                <Column field="status" header="STATUS" body={statusTemplate} />
                <Column field="unit" header="UNIT TARGET" body={unitTemplate} />
                <Column field="policeNumber" header="NOMOR POLISI" />
                <Column field="contactName" header="KONTAK DIHUBUNGI" body={contactTemplate} />
                <Column field="location" header="LOKASI" />
                <Column header="KELOLA" body={kelolaBodyTemplate} />
            </DataTable>
            <ModalFinishInspectionMultiple dataSelected={selectedCustomers} onCallback={(e) => onCallback(e)} show={confirmSetStatusDialog} close={() => setConfirmSetStatusDialog(false)} status={devStatus} />
        </Container>
    );
}

export default TableInspeksi;
